
export const htmlToPlainText = (html?: string | null) => (html || "").replace(/<[^>]+>/g, '').toString();